import React, { useEffect } from "react";

import { AssociateContentStandaloneForm } from "../../../../../../content-ingestion/common/content/forms/AssociateContentStandaloneForm";
import { mapToContentAssociationFormState, useEditOnPremAssetContentForm } from "./useEditOnPremAssetContentForm";

export const EditOnPremAssetContentForm = (): JSX.Element => {
    const {
        setDefaultContentState,
        defaultContentState,
        isDefaultContentLoading,
        setIsDefaultContentLoading,
        backToAssetDetails,
        assetDetails,
        onSubmit,
        validate
    } = useEditOnPremAssetContentForm();

    useEffect(() => {
        if (assetDetails) {
            setDefaultContentState(mapToContentAssociationFormState(assetDetails));
            setIsDefaultContentLoading(false);
        }
    }, [assetDetails]);

    return (
        <AssociateContentStandaloneForm
            onSubmitValidate={validate}
            onSubmit={onSubmit}
            onCancel={backToAssetDetails}
            isDefaultContentLoading={isDefaultContentLoading}
            defaultContentState={defaultContentState}
            infoMessage={
                "A new asset will be created on submit. Please make sure all information is correct. Changes will be applied only to the current asset, other related assets must be updated manually."
            }
        />
    );
};
